import { jsx as _jsx } from "react/jsx-runtime";
import { zebraRowClasses, zebraTableClasses, zebraTableHeadRowClasses, zebraTdClasses, zebraThClasses, } from './styles.js';
/**
 * v2 ゼブラ表 primitive（S-133）。縦横線なし・見出し行は bg-surface-2（両端 8px 角丸）・
 * 本文は偶数行 bg-surface-2。thead / tbody は呼び出し側が置き、行とセルに下の部品を使う:
 *
 *   <ZebraTable aria-label="配信別">
 *     <thead><ZebraTable.HeadRow><ZebraTable.Th edge="first">配信</ZebraTable.Th> … </ZebraTable.HeadRow></thead>
 *     <tbody><ZebraTable.Row><ZebraTable.Td>…</ZebraTable.Td><ZebraTable.Td numeric>3</ZebraTable.Td></ZebraTable.Row></tbody>
 *   </ZebraTable>
 */
export function ZebraTable({ className, ...rest }) {
    return _jsx("table", { className: zebraTableClasses(className), ...rest });
}
function HeadRow({ className, ...rest }) {
    return _jsx("tr", { className: zebraTableHeadRowClasses(className), ...rest });
}
function Th({ align, edge, className, ...rest }) {
    return _jsx("th", { className: zebraThClasses({ align, edge, className }), ...rest });
}
function Row({ className, ...rest }) {
    return _jsx("tr", { className: zebraRowClasses(className), ...rest });
}
function Td({ align, numeric, tone, padding, className, ...rest }) {
    return (_jsx("td", { className: zebraTdClasses({ align, numeric, tone, padding, className }), ...rest }));
}
ZebraTable.HeadRow = HeadRow;
ZebraTable.Th = Th;
ZebraTable.Row = Row;
ZebraTable.Td = Td;
//# sourceMappingURL=ZebraTable.js.map